import PropTypes from 'prop-types';
import React from 'react';
import pick from 'lodash/pick';

import Header from './header';
import UserSearchBox from '../search/userSearchBox';
import AdminShopSearchBox from '../search/AdminShopSearchBox';

const SearchHeader = (props) => {
  const headerProps = pick(props, ['button', 'type', 'link', 'heading', 'children', 'dropdown', 'className']);
  const { type } = headerProps;

  return (
    <Header
      button={headerProps.button}
      type={headerProps.type}
      link={headerProps.link}
      heading={headerProps.heading}
      dropdown={headerProps.dropdown}
      className={headerProps.className}
    >
      <div className="c-header-primary__components">
        {props.admin ? (
          <AdminShopSearchBox type={type} />
        ) : (
          <UserSearchBox type={type} visibleInContainerApp={props.visibleInContainerApp} />
        )}
      </div>
      {props.children}
    </Header>
  );
};

SearchHeader.propTypes = {
  button: PropTypes.string, // eslint-disable-line
  type: PropTypes.oneOf(['user', 'shop', 'appointment', 'client', 'barber', 'link']), // eslint-disable-line
  link: PropTypes.string, // eslint-disable-line
  heading: PropTypes.string, // eslint-disable-line
  children: PropTypes.node, // eslint-disable-line
  dropdown: PropTypes.oneOfType([ // eslint-disable-line
    PropTypes.node,
    PropTypes.func,
  ]),
  admin: PropTypes.bool,
  visibleInContainerApp: PropTypes.bool,
};

SearchHeader.defaultProps = {
  admin: false,
  dropdown: false,
  visibleInContainerApp: false,
};

export default SearchHeader;
